import axios from "axios";
import toast from "@/commom/toast";
import Vue from "vue";


export const axiosHTTP = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

axiosHTTP.interceptors.request.use(function(config) {
  const token = Vue.$keycloak.token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axiosHTTP.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      Vue.$keycloak.logout();
    }
    if (error.response.status === 403) {
      toast("error", "Sem permissão de acesso");
    }
    return Promise.reject(error);
  }
);

export default axiosHTTP;
